// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"a43d441e","453":"8c875ba2"}[chunkId] + ".chunk.js";
};